module.exports = __webpack_public_path__ + "images/5ce429d0e595fada211c14be7ac2be1c.svg";